import React from 'react';

interface AuthTabsProps {
  activeTab: number;
  setActiveTab(v: number): void;
}

export const AuthTabs = ({ activeTab, setActiveTab }: AuthTabsProps) => {
  return (
    <div className="flex justify-center gap-2 mb-4 mt-4">
      <button
        onClick={() => setActiveTab(0)}
        className={`px-4 py-1 text-sm font-semibold transition border-b-2 ${
          activeTab === 0
            ? 'text-black border-black'
            : 'text-gray-500 border-transparent'
        }`}
      >
        Login
      </button>
      <button
        onClick={() => setActiveTab(1)}
        className={`px-4 py-1 text-sm font-semibold transition border-b-2 ${
          activeTab === 1
            ? 'text-black border-black'
            : 'text-gray-500 border-transparent'
        }`}
      >
        Sign Up
      </button>
    </div>
  );
};
